"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepReservationOverview = void 0;
const react_1 = __importDefault(require("react"));
const AbstractForm_1 = require("../../HOC/AbstractForm");
const ReservationOverviewButtons_1 = require("./ReservationOverviewButtons");
const ReservationOverviewInfo_1 = require("./ReservationOverviewInfo");
require("./index.scss");
const className = 'reservation-overview';
class StepReservationOverview extends AbstractForm_1.AbstractForm {
    constructor() {
        super(...arguments);
        this.initState = () => {
            const { formData, } = this.props;
            return {
                formData: {
                    ...formData,
                },
            };
        };
        this.state = this.initState();
        this.handleSubmitButton = (event) => {
            event.preventDefault();
            this.props.onSubmit();
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formData.isAgree !== this.props.formData.isAgree) {
            this.setState({
                formData: this.props.formData,
            });
        }
    }
    render() {
        const { isSubmitButtonDisabled, flights, title, } = this.props;
        const { formData, } = this.state;
        const { isAgree, } = formData;
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement("div", { className: `${className}__info` },
                react_1.default.createElement(ReservationOverviewInfo_1.ReservationOverviewInfo, { flights: flights, totalPrice: this.props.totalPrice, passengers: this.props.passengers, title: title })),
            react_1.default.createElement("div", { className: `${className}__buttons` },
                react_1.default.createElement(ReservationOverviewButtons_1.ReservationOverviewButtons, { isAgree: !!isAgree, agreementErrors: this.getFormError('password'), onAgreementChange: event => this.handleFormInputChangeCheckBox(event, 'isAgree'), isSubmitButtonDisabled: isSubmitButtonDisabled, onSubmitClick: this.handleSubmitButton }))));
    }
}
exports.StepReservationOverview = StepReservationOverview;
//# sourceMappingURL=index.js.map